import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";

const SuccessStatCard = ({ headerTag, count, time }) => {
  const [startCount, setStartCount] = useState(false);

  // Intersection observer to detect when the card is in view
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once
    threshold: 0.3, // Start animation when 30% of the card is visible
    onChange: (inView) => {
      if (inView) setStartCount(true);
    },
  });

  return (
    <div
      ref={ref}
      className="p-2 shadow-md rounded-md bg-cover bg-center relative w-full ml-0 transform transition-all duration-300 ease-in-out hover:scale-105"
      style={{
        backgroundImage: `url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSaAhdW_KVoO4WldSKV5kTmFEtNSp0P_7DIPybIGrcM8lgVZfIg")`,
      }}
    >
      <div className="bg-white bg-opacity-80 p-4 rounded-md">
        <h5 className="mt-4 mb-2 text-lg font-medium">{headerTag}</h5>
        <div className="flex items-center mt-3">
          <h3 className="text-2xl font-bold m-0">
            {startCount ? (
              <CountUp
                end={parseFloat(count.replace(/[₹,]/g, ""))}
                duration={2.5}
                separator=","
                prefix={count.startsWith("₹") ? "₹" : ""}
              />
            ) : (
              <span>{count.startsWith("₹") ? "₹0" : "0"}</span>
            )}
          </h3>
        </div>
        <p className="text-sm text-gray-500 mt-1">{time}</p>
      </div>
    </div>
  );
};

export default SuccessStatCard;
